import request from '../utils/request'

export function customerAppExpansionListPageApi (data) {
  return request({
    url: 'api/customer/appExpansionListPage',
    method: 'post',
    data
  })
}

export function arsMaterieQueryListApi (data) {
  return request({
    url: 'api/arsMateriel/queryList',
    method: 'post',
    data
  })
}

export function customerExpansionMapListPageApi (data, cancelToken) {
  return request({
    url: 'api/customer/appExpansionMapListPage',
    method: 'post',
    data,
    cancelToken
  })
}

export function arsProductInventoryListApi (params) {
  return request({
    url: 'api/arsProduct/productInventoryList',
    method: 'get',
    params
  })
}
